/* eslint-disable no-unused-vars */
/* eslint-disable max-len */
import { Divider } from "@mui/material";
import React from "react";
import UrgentCareTransitionCard from "./UrgentCareTransitionCard";
import { StyledBookingFlowButton } from "../../containers/BookingScheduleContainer/BookingScheduleContainer.style";
import ReasonForVisitCard from "../ExpressServiceUpsellModal/ReasonForVisitCard";
import { LOCATIONS_URL, MODALS, URGENT_CARE_TRANSITION_SERVICES } from "../../../config/params";
import UrgentServicesIcon from "../../../components/Icons/UrgentServicesIcon";
import { useUserDetail } from "../../../services/user-detail/user-detail.service";
import { useModal } from "../../../context/ModalContext";

const UrgentCareTransitionModal = () => {
  const { user } = useUserDetail();
  const { openModal } = useModal();


  const handleContactCtaClick = () => {
    openModal(MODALS.OVERDUE_CONTACT_MODAL);
  };

  const getBaseUrl = () => {
    switch (process.env.REACT_APP_NODE_ENV) {
    case "staging":
      return "https://staging.goodvets.com/locations";
    case "production":
      return "https://goodvets.com/locations";
    default:
      return "https://dev.goodvets.com/locations";
    }
  };

  const handleBookingCtaClick = () => {
    window.open(`${getBaseUrl()}/${user?.location?.city.split(" ").join("-").toLowerCase()}/${user?.location?.locationName.split(" ").join("-").toLowerCase()}`, "_blank");
  };

  const handleLogOutCta = () => {
    openModal(MODALS.LOGOUT);
  };

  return (
    <div className="h-full flex flex-col items-center justify-between">
      <div className="w-full pt-8">
        <UrgentCareTransitionCard />
      </div>
      <Divider className="w-full !mt-2" />
      <div
        className="min-h-0 w-full flex flex-col flex-1 my-2 gap-1.5 items-center
        max-2xl:max-h-[15rem] scrollbar-thin overflow-y-auto">
        <div className="text-sm font-semibold">
            Urgent Care  Services at <span className="capitalize">{user?.location?.locationName}</span>
        </div>
        <div className="w-full grid grid-cols-2 justify-items-center
        gap-2 px-1">
          {URGENT_CARE_TRANSITION_SERVICES.map((reason, index)=>{
            return (
              <ReasonForVisitCard
                key={index}
                title={reason.label}
                isSelected={false}
                value={reason.value}
                icon={<UrgentServicesIcon />}
                iconColor="bg-orange-2"
              />
            );
          })}
        </div>
      </div>
      <div className="w-full flex flex-col gap-1 items-center">
        <StyledBookingFlowButton
          disabled={false}
          size="small"
          className="w-full !bg-orange-1 hover:!bg-black !text-sm"
          onClick={handleBookingCtaClick}
        >
           Book an Urgent Visit
        </StyledBookingFlowButton>
        <div onClick={handleContactCtaClick}
          className="w-full border border-gray-4 rounded-[6.25rem] py-2 mb-1 cursor-pointer
        px-5 flex justify-center text-sm font-semibold hover:bg-gray-3">
          {"Contact Hospital"}
        </div>

        <div
          onClick={handleLogOutCta}
          className="text-gray-1 font-semibold text-sm cursor-pointer hover:text-black">
          Log Out
        </div>
      </div>
    </div>
  );
};

export default UrgentCareTransitionModal;
